export const getFrameRate = (component) => {
  const frameRateNumerator = component.attributes?.frameRate?.numerator;
  const frameRateDenominator = component.attributes?.frameRate?.denominator;
  let frameRate = "Unknown frame rate";
  if (frameRateNumerator && frameRateDenominator) {
    frameRate = `${(frameRateNumerator / frameRateDenominator).toLocaleString(
      "en-US",
      {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }
    )} FPS`;
  }
  return frameRate;
};

export const getEditRate = (editRateObj) => {
  const editRateNumerator = editRateObj?.numerator;
  const editRateDenominator = editRateObj?.denominator;
  let editRate = "NA";
  if (editRateNumerator && editRateDenominator) {
    editRate = `${Number((editRateNumerator / editRateDenominator).toLocaleString(
      "en-US",
      {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }
    )) * 100}`;
  }
  return editRate;
};

const gcd = (a, b) => {
  return (b === 0) ? a : gcd (b, a%b);
};

export const getAspectRatio = (width, height) => {
  let r = gcd(width, height);
  return `${width/r}:${height/r}`;
};

export const normalizeCantemoComponents = (manifestationObj) => {
  const fileFormat = manifestationObj?.attributes?.fileFormat;
  if (fileFormat !== "CC / Subtitle Media" && fileFormat !== "Misc File Media") {
    return;
  }
  manifestationObj?.components?.forEach((component) => {
    if (!component.componentType) {
      component.componentType = "timed-text";
    }
  });
};
